import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import ArMap from 'src/components/ArMap/ArMap'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import ArSectionHeading from 'src/components/typography/ArSectionHeading'
import ArParagraph from 'src/components/typography/ArParagraph'
import ArMonoTag from 'src/components/typography/ArMonoTag'

import ArSectionDescription from 'src/components/typography/ArSectionDescription'
import { media } from 'src/styles/styled-components'

const StyledWrapper = styled.section`
  background-color: ${ p => p.theme.colors.asfalt };
  padding-bottom: 20px;
  padding-top: 30px;

  ${ media.tablet`
    padding-top: 80px;
  ` }

  ${ media.desktop`
    padding: 80px 0px 100px 0px;
    background-color: ${ p => p.theme.colors.codGray };
  ` }
`

const StyledContainer = styled(ArBaseContainer)``

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 80px;
`

const StyledTitle = styled(ArSectionHeading)`
  color: ${ p => p.theme.colors.white };
`

const StyledDescription = styled(ArSectionDescription)`
  color: ${ p => p.theme.colors.white };
  max-width: 800px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  `

const StyledItem = styled.div`
  margin-bottom: 30px;
  overflow: hidden;

  ${ media.tablet`
    margin-bottom: 60px;
    display: flex;
    justify-content: flex-start;
  ` }

  ${ media.desktop`
    justify-content: center;
    margin-top: 100px;

    &:nth-child(1){
      margin-top: 78px;
    }
  ` }
`

const StyledItemText = styled.div`
  ${ media.tablet`
    display: flex;
    justify-content: center;
    flex-direction: column;
  ` }

  ${ media.desktop`
    width: calc(100% - 500px - 90px);
    max-width: 350px;
  ` }
`

const StyledItemCity = styled.h3`
  color: ${ p => p.theme.colors.white };
  font-size: 1.8rem;
  letter-spacing: 0.01em;
  line-height: 1.55;
  margin-top: 20px;

  ${ media.tablet`
    margin-top: 0px;
  ` }

  ${ media.desktop`
    font-size: 31px;
    line-height: 1.19;
  ` }
`

const StyledItemFullAddress = styled(ArMonoTag)``

const StyledItemPhone = styled(ArMonoTag)`
  color: ${ p => p.theme.colors.accent };
`

const StyledItemDescription = styled(ArParagraph)`
  color: ${ p => p.theme.colors.white };
  margin-top: 10px;

  ${ media.tablet`
    margin-top: 16px;
  ` }

  ${ media.desktop`
    margin-top: 10px;
  ` }
`

class ArLocations extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    locations: PropTypes.arrayOf(PropTypes.shape({
      geoPosition: PropTypes.object,
      city: PropTypes.string,
      phone: PropTypes.string,
      fullAddress: PropTypes.string,
      description: PropTypes.string,
    })),
  }

  render () {
    const { title, description, locations } = this.props

    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledTitle>{title}</StyledTitle>
          <StyledDescription>{description}</StyledDescription>

          <StyledColumn>
            {locations.map(({ geoPosition, city, phone, fullAddress, description }, index) =>
              <StyledItem key={index}>
                <ArMap
                  lat={geoPosition.lat}
                  lng={geoPosition.lng}
                />

                <StyledItemText>
                  <StyledItemCity>{city}</StyledItemCity>
                  <StyledItemFullAddress>{fullAddress}</StyledItemFullAddress>
                  {phone && <StyledItemPhone>{phone}</StyledItemPhone>}
                  <StyledItemDescription>{description}</StyledItemDescription>
                </StyledItemText>
              </StyledItem>
            )}
          </StyledColumn>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArLocations
